import { render } from "./InfoGroupControl.vue?vue&type=template&id=fff8c840&scoped=true"
import script from "./InfoGroupControl.vue?vue&type=script&lang=js"
export * from "./InfoGroupControl.vue?vue&type=script&lang=js"

import "./InfoGroupControl.vue?vue&type=style&index=0&id=fff8c840&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff8c840"]])

export default __exports__